export const confirmations = {
  passwordReset: {
    title: 'Your request has been received.',
    description: `An email with instructions on how to reset your password has been sent to your email address on file.
      If you don't know the email address or no longer have access to it call DAR at (808) 587-0109.`
  }
};
